import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../redux";
import { TypesAction } from "../redux/typesAction";
import { callHttpClientMethod } from "../services/callHttpClient";
import { countReadUnNoti, seenAll } from "../services/apiList";
import { BASE_URL, HttpMethod } from "../services/api.constant";

const PUBLIC_PATHS = new Set([
  "/login",
  "/register",
  "/forgotPassword",
  "/validateOtp",
]);

export function useAppAuthGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth } = useSelector((state: RootState) => state?.auth);

  const refreshUnreadCount = useCallback(async () => {
    if (!auth?.access_token) return;
    try {
      const response = await callHttpClientMethod(
        BASE_URL + countReadUnNoti(),
        HttpMethod.Get,
        {},
        {
          headers: {
            Authorization: `Bearer ${auth.access_token}`,
          },
        }
      );
      if (response?.status_code == 200) {
        dispatch({ type: TypesAction?.COUNT_NOTI, payload: response?.data });
      }
    } catch {
      /* optional: log to monitoring */
    }
  }, [auth?.access_token, dispatch]);

  const markAllNotificationsSeen = useCallback(async () => {
    if (!auth?.access_token) return;
    const response = await callHttpClientMethod(
      BASE_URL + seenAll(),
      HttpMethod.Post,
      {},
      {
        headers: {
          Authorization: `Bearer ${auth.access_token}`,
        },
      }
    );
    if (response?.status_code == 200) {
      await refreshUnreadCount();
    }
  }, [auth?.access_token, refreshUnreadCount]);

  useEffect(() => {
    const path = location?.pathname ?? "";
    const isPublic = PUBLIC_PATHS.has(path);

    if (!isPublic && !auth?.access_token) {
      navigate("/login", { replace: true });
      return;
    }

    if (path === "/notifications") {
      markAllNotificationsSeen();
    }
  }, [
    auth?.access_token,
    location?.pathname,
    markAllNotificationsSeen,
    navigate,
  ]);
}
